module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Payment methods","subtitle":"To add a new card, we will block and unlock 1 ruble from your card. You will be redirected to the payment system\u0027s website.","noPaymentMethods":"Please add a payment method"}}')
  delete Component.options._Ctor
}
